export default __webpack_public_path__ + "static/media/global.6bb53729.svg";